import React from 'react';
import { ResponsiveContainer, LineChart, Line, XAxis, YAxis, Tooltip, Legend, CartesianGrid } from 'recharts';
import { TrendingUp } from 'lucide-react';
import { hostOf } from './CompetitorPositionBadge';

const COLORS = ['#2563eb', '#16a34a', '#9333ea'];

const CompetitorPriceChart = ({ history = [], urls = [] }) => {
  const points = [...history].reverse().map(s => {
    const row = { date: new Date(s.fetched_at).toLocaleDateString('fr-FR', { day: '2-digit', month: '2-digit', year: '2-digit' }), full: new Date(s.fetched_at).toLocaleString('fr-FR'), Nous: s.our_price_at_fetch ?? s.our_price };
    s.competitors.forEach(c => { row[`C${c.slot}`] = c.status === 'ok' && c.price != null ? c.price : null; });
    return row;
  });
  if (points.length < 2) {
    return <p className="text-xs text-gray-500 border rounded-lg p-4" data-testid="competitor-chart-empty">Le graphique apparaîtra dès le deuxième relevé.</p>;
  }
  const slots = [1, 2, 3].filter(s => points.some(p => p[`C${s}`] != null));
  return (
    <div className="border rounded-lg p-4" data-testid="competitor-chart">
      <h4 className="font-semibold text-gray-900 flex items-center gap-2 mb-2"><TrendingUp size={16} className="text-orange-500" /> Évolution des prix</h4>
      <ResponsiveContainer width="100%" height={240}>
        <LineChart data={points} margin={{ top: 8, right: 16, left: 0, bottom: 0 }}>
          <CartesianGrid strokeDasharray="3 3" stroke="#e5e7eb" />
          <XAxis dataKey="date" tick={{ fontSize: 11 }} />
          <YAxis tick={{ fontSize: 11 }} tickFormatter={(v) => `${v} €`} domain={['auto', 'auto']} width={64} />
          <Tooltip formatter={(v, name) => [v == null ? 'Non récupéré' : `${Number(v).toFixed(2)} €`, name]} labelFormatter={(_, payload) => payload?.[0]?.payload?.full || ''} contentStyle={{ fontSize: 12 }} />
          <Legend wrapperStyle={{ fontSize: 12 }} formatter={(v) => (v === 'Nous' ? 'Notre prix' : `${v}${urls[Number(v.slice(1)) - 1] ? ` · ${hostOf(urls[Number(v.slice(1)) - 1])}` : ''}`)} />
          <Line type="monotone" dataKey="Nous" stroke="#f97316" strokeWidth={3} dot={{ r: 4 }} connectNulls />
          {slots.map((s, i) => <Line key={s} type="monotone" dataKey={`C${s}`} stroke={COLORS[i]} strokeWidth={2} dot={{ r: 3 }} connectNulls strokeDasharray={i ? '4 2' : undefined} />)}
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
};

export default CompetitorPriceChart;
